import React, {Component} from "react"
import {Modal, SearchBar,Toast} from 'antd-mobile';
import {getLabel, getProvince, historyStation} from "../../service/homeService";
import "./style.less";

let curList = [
    // {key:"B",arr:[{name:"包谷垴乡、老店镇",lng:"103.360085",lat:"26.983553"},{name:"北京市",lng:"103.360085",lat:"26.983553"} ]},
    // {key:"D",arr:[{name:"大关县",lng:"103.360085",lat:"26.983553"}]},
    // {key:"G",arr:[{name:"耿马县",lng:"103.360085",lat:"26.983553"}]},
    // {key:"H",arr:[{name:"会泽县",lng:"103.360085",lat:"26.983553"}]},
    // {key:"L",arr:[{name:"临沧市",lng:"103.360085",lat:"26.983553"}, {name:"鲁甸县",lng:"103.360085",lat:"26.983553"}]},
    // {key:"T",arr:[{name:"腾冲县",lng:"103.360085",lat:"26.983553"}]},

]


;
let listDom = [];
let flag =[];
let provinceFlag =false;
export default class CityModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            city:"",
            // onFocus:false,
            flag:[],
            provinceFlag:false,
            letterList:[],
            letterIndex:-1,
            historyData:[],
            provinceData:[],
        };
    }

    componentDidMount  () {
        // console.log(this.props)
        if(this.props.cityType === "intercity" || this.props.cityType === "charteredBus" || this.props.cityType === "bringGood"){
            getLabel({ source: 1, token:this.props.userInfo.token,}).then((res)=>{
                if(res.data.code === '0000'){
                    this.setState({letterList:res.data.data})
                }else{
                    Toast.info(res.data.msg)
                }
            });
            getProvince({ source: 1, token:this.props.userInfo.token,}).then((res)=>{
                if (res.data.code === '0000') {
                    res.data.data.unshift({name:'全部',id:""});
                    this.setState({provinceData: res.data.data});
                }else{
                    Toast.info(res.data.msg,3)
                }
            })
        }
        // if(this.props.cityType === "intercity"){
        //     if(this.props.modalType == "start"){
        //         this.getHistory(0)
        //     }else{
        //         this.getHistory(1)
        //     }
        // }
    }
    componentDidUpdate(){
        // console.log(this.props)
    }
    getHistory(type){
        const params = {
            source:1,
            token:this.props.userInfo.token,
            data:{type:type},
        };
        historyStation(params).then((res)=>{
            if (res.data.code === '0000') {
                this.setState({historyData: res.data.data});
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    }
    onScrollHandle(res,i) {
        this.tabDOM.scrollTop = listDom[i].offsetTop - (document.documentElement.clientWidth / 750 * 102);
        // this.tabDOM.scrollTo(0,listDom[i].offsetTop - (document.documentElement.clientWidth/750*196));
    }
    cityClick(city){
        let cityIndex = "";
        let cityIndexArr = "";
        curList.map((res,i)=>{
            res.arr.map((n,index)=>{
                if(n.name === city){
                    console.log(n);
                    cityIndex = i;
                    cityIndexArr = index;
                }
            })

        });
        if(cityIndexArr == ""){
            Toast.info('当前城市暂未开通！')
        }else{
            console.log(cityIndex,cityIndexArr)
        }
    }

    listDOM(instance) {
        if (instance) {
            listDom.push(instance)
        }
    }
    cityChange(n){
        n.flag= !n.flag;
        this.setState({flag:flag});
    }
    serChange(value){
        listDom=[];
        this.props.searchChange(value, this.props.modalType)
    }
    hotScroll(){
        this.tabDOM.scrollTop = 0
    }
    goPage(){
        this.props.onClose()
        this.setState({provinceFlag:false,letterIndex:-1,})
        // if(this.props.cityType === 'intercity'){
        //     this.props.history.goBack()
        // }else{
        //     this.props.onClose()
        // }
    }
    uncheck(res){
        this.props.changeCity(res)
        this.setState({letterIndex:-1,})
    }
    changeCityPage(){
        return(
            <div>
                {
                    this.props.nearbySite.length > 0 ? (
                        <div className="curtCity"  >
                            附近上车点  <i className="icon iconfont iconmudedi"/><span onClick={() => this.uncheck(this.props.nearbySite)}>{this.props.nearbySite.name}</span>
                        </div>
                    ):null
                }
                {
                    this.props.cityType == "intercity" ? (
                        <div className="history">
                            <div className="title">历史城市</div>
                            {
                                this.props.historyData && this.props.historyData.length == 0 ? <div className="noRecord">暂无记录</div> : this.props.historyData.map((res,i)=>(
                                    <div className="cityDiv" key={i}><span onClick={() => this.uncheck(res)}>{res.name}</span></div>
                                ))
                            }
                        </div>
                    ):null
                }
                {
                    this.props.hotData == "" || this.props.cityType == "city"  ? null : (
                        <div className="hotCity"  >
                            <div className="title">热门城市</div>
                            <div className="hotText">
                                {
                                    this.props.hotData.map((res,i)=>(
                                        <span  onClick={() => this.uncheck(res)} key={i}>{res.name}</span>
                                    ))
                                }
                                {/*<span onClick={() => this.cityClick("巧家县")}>巧家县</span><span>大理白族自治州</span><span>个旧市</span><span>弥勒市</span><span>昆明市</span>*/}
                            </div>
                        </div>
                    )
                }

                <div className="cityList" >
                    {this.typeBylist()}
                </div>
            </div>
        )
    }
    typeBylist(){
        if(this.props.cityType == "city"){
            return (
                this.props.data && this.props.data.map((res, i) => (
                    <div  className="cityDiv"  key={i} ref={this.listDOM} >
                        <span className="cityItem" onClick={() => this.uncheck(res)}>{res.name}</span>
                    </div>
                ))
            )
        }else{
            curList = [];
            for (let k in this.props.data) {
                curList.push({
                    key: k,
                    arr: this.props.data[k],
                });
            }
            return (
                curList.map((res, i) => (
                    <div className="listgroup" key={i} ref={this.listDOM}  >
                        <div className="title J_scroll_title">{res.key}</div>
                        <div  className="cityDiv">
                            {res.arr.map((n,index)=>(
                                <span key={index} className="cityItem" onClick={() => this.uncheck(n)}>{n.name}</span>
                            ))}
                        </div>
                    </div>
                ))
            )

        }

    }
    letterChange(res,i,type){
        this.setState({letterIndex :i});
        if(type == "start"){
            this.props.getStartCityList(this.props.province,res)
        }else{
            this.props.getEndCityList(res)
            // if(this.props.cityType == "charteredBus"){
            //     this.props.getEndCityList(res)
            // }else{
            //     const props = this.props.location.state;
            //     const params = {
            //         source: 1,
            //         token:this.props.userInfo.token,
            //         data:{
            //             // displayName:props.startCity,
            //             position:props.startPoi.lat + '_'+ props.startPoi.lng,
            //             label:res,
            //         }
            //     };
            //     this.props.getEndCityList(params,[])
            // }
        }
    }
    getHeader(){
        if(this.props.cityType == "city" || this.props.cityType == "runCar"){
            return(
                <div className="modalTopBar">
                    <i className="icon iconfont iconfanhui" onClick={() => this.goPage()} />
                    <div className="endTitle" >选择出发地</div>
                </div>
            )
        }
        if(this.props.modalType === 'start'){
            return(
                <div className="header" style={this.state.provinceFlag ? {height:"100%"} : null}>
                    <div className="modalTopBar">
                        <i className="icon iconfont iconfanhui" onClick={() => this.goPage()} />
                        <div className="endTitle" >选择出发地</div>
                    </div>
                    <div className="province" onClick={()=>{
                        provinceFlag = !provinceFlag;
                        this.setState({provinceFlag})
                    }}>
                        <span>选择省份:</span>
                        <span className="provinceText">{this.props.province}</span>
                        <span className="provinceChange">切换</span>
                    </div>
                    {
                        this.state.provinceFlag ? (
                            <div className="provinceList">
                                {
                                    this.state.provinceData.map((res,i)=>{
                                        return <div key={i} onClick={()=>{
                                            this.setState({provinceFlag:false,letterIndex:-1});
                                            this.props.getStartCityList(res.name,"")
                                        }}><i className="icon iconfont iconSic"/> {res.name}</div>
                                    })
                                }
                            </div>
                        ):null
                    }
                    <div className="letter">
                        <span className="allText" onClick={()=>this.letterChange("",-1,"start")}>全部</span>
                        {
                            this.state.letterList.map((res,i)=>{
                                return  <span key ={i} className={this.state.letterIndex == i ? "text active" : "text"} onClick={()=>this.letterChange(res,i,"start")}>{res}</span>
                            })
                        }
                    </div>
                </div>
            )
        }else{
            return(
                <div className="header">
                    <div className="modalTopBar">
                        <i className="icon iconfont iconfanhui" onClick={() => this.goPage()} />
                        <div className="endTitle" >选择目的地</div>
                    </div>
                    <div className="prompt">
                        {
                            this.props.data == "" ? "您选择的上车地址不在接送范围，请尝试返回上页并更改上车地址！":
                                "如果您的目的地不在下面列表中，可能是您的上车地址不在接送范围内，请尝试返回上页并更改上车地址！"
                        }
                    </div>
                    <div className="letter">
                        <span className="allText" onClick={()=>this.letterChange("",-1,"end")}>全部</span>
                        {
                            this.state.letterList.map((res,i)=>{
                                return  <span key ={i} className={this.state.letterIndex == i ? "text active" : "text"} onClick={()=>this.letterChange(res,i,"end")}>{res}</span>
                            })
                        }
                    </div>
                </div>
            )
        }
    }
    render() {
        if(this.props.modal === false){
            listDom=[];
        }
        return (
            <Modal
                className="citySelectModal"
                visible={this.props.modal}
                onClose={() => this.props.onClose()}
                destroyOnClose={true}
                maskClosable={false}
            >
                {this.getHeader()}

                <div className='content' ref={dom => {this.tabDOM = dom}}>
                    {this.changeCityPage()}
                    {/*<div>
                        {
                            this.props.nearbySite.length > 0 ? (
                                <div className="curtCity"  >
                                    附近上车点  <i className="icon iconfont iconmudedi"/><span onClick={() => this.props.changeCity(this.props.nearbySite)}>{this.props.nearbySite.name}</span>
                                </div>
                            ):null
                        }
                        {
                            this.props.hotData == "" || this.props.cityType == "city"  ? null : (
                                <div className="hotCity"  >
                                    <div className="title">热门城市</div>
                                    <div className="hotText">
                                        {
                                            this.props.hotData.map((res,i)=>(
                                                <span  onClick={() => this.props.changeCity(res)} key={i}>{res.name}</span>
                                            ))
                                        }
                                        <span onClick={() => this.cityClick("巧家县")}>巧家县</span><span>大理白族自治州</span><span>个旧市</span><span>弥勒市</span><span>昆明市</span>
                                    </div>
                                </div>
                            )
                        }

                        <div className="cityList" >
                            {this.typeBylist()}
                        </div>
                    </div>*/}

                </div>

               {/* <div className="city_anchor_hot">
                    <a onClick={() => this.hotScroll()}>定位</a>
                    <a onClick={() => this.hotScroll()}>热门</a>
                </div>
                <div className="city_anchor">
                    {
                        curList.map((res, i) => {
                            return (
                                <a key={i} onClick={() => this.onScrollHandle(res,i)}>
                                    {res.key}
                                </a>
                            )
                        })
                    }
                </div>*/}
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/CityModal/index.js